import {
  AiContentGenerator01Icon,
  AiIdeaIcon,
  AiWebBrowsingIcon,
  Calendar01Icon,
  ChatSpark01Icon,
  CheckmarkSquare01Icon,
  CopyLinkIcon,
  DateTimeIcon,
  FolderIcon,
  HashtagIcon,
  Link01Icon,
  Mail01Icon,
  TelephoneIcon,
  TextCircleIcon,
  Tick01Icon,
  TickDouble01Icon,
  UserIcon,
  UserMultipleIcon,
} from "@hugeicons/core-free-icons"

export const HIDDEN_ATTRIBUTE_TYPE_KEYS = new Set(["long_text", "json"])

export const AI_AUTOFILL_TYPE_META = {
  web_research_agent: { label: "Веб-ресерч", icon: AiWebBrowsingIcon },
  prompt_completion: { label: "Промпт-комплишен", icon: ChatSpark01Icon },
  summarize_record: { label: "Суммаризация", icon: AiContentGenerator01Icon },
  classify_record: { label: "Классификация", icon: AiIdeaIcon },
} as const

const ATTRIBUTE_TYPE_META: Record<string, { label: string; description: string; icon: unknown }> = {
  text: {
    label: "Текст",
    description: "Короткое текстовое значение.",
    icon: TextCircleIcon,
  },
  number: {
    label: "Число",
    description: "Числовое значение.",
    icon: HashtagIcon,
  },
  checkbox: {
    label: "Чекбокс",
    description: "Да или нет.",
    icon: CheckmarkSquare01Icon,
  },
  date: {
    label: "Дата",
    description: "Календарная дата.",
    icon: Calendar01Icon,
  },
  datetime: {
    label: "Дата и время",
    description: "Дата и точное время.",
    icon: DateTimeIcon,
  },
  url: {
    label: "Ссылка",
    description: "Веб-ссылка.",
    icon: Link01Icon,
  },
  email: {
    label: "Email",
    description: "Электронная почта.",
    icon: Mail01Icon,
  },
  phone: {
    label: "Телефон",
    description: "Номер телефона.",
    icon: TelephoneIcon,
  },
  select: {
    label: "Выбор",
    description: "Одно значение из списка опций.",
    icon: Tick01Icon,
  },
  multi_select: {
    label: "Мультиселект",
    description: "Несколько значений из списка опций.",
    icon: TickDouble01Icon,
  },
  reference: {
    label: "Связь",
    description: "Ссылка на запись другого объекта.",
    icon: CopyLinkIcon,
  },
}

export function getAttributeIcon(attributeType: string, targetObjectType?: string): any {
  if (attributeType === "reference_list" && targetObjectType === "person") {
    return UserMultipleIcon
  }
  if (attributeType === "user" || targetObjectType === "person") {
    return UserIcon
  }
  if (targetObjectType === "project") {
    return FolderIcon
  }
  return ATTRIBUTE_TYPE_META[attributeType]?.icon ?? TextCircleIcon
}

export function getAttributeTypeMeta(
  typeKey: string,
  fallback?: {
    label?: string
    description?: string
  },
) {
  const meta = ATTRIBUTE_TYPE_META[typeKey]
  if (meta) return meta
  return {
    label: fallback?.label ?? typeKey,
    description: fallback?.description ?? "",
    icon: TextCircleIcon,
  }
}
